import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { Title, useClassnames } from '@wb-tech/ui-react';

import style from './index.module.pcss';

export const Route404 = () => {
    const cn = useClassnames(style);
    const { t } = useTranslation();

    return (
        <div className={cn('route-404')}>
            <Title
                tagName="h1"
                className={cn('route-404__title')}
            >
                {t('routes.404.title')}
            </Title>
            <Trans
                parent="p"
                className={cn('route-404__desc')}
                i18nKey="routes.404.description"
                components={{
                    'link-main': <Link to="/" />
                }}
            />
        </div>
    );
};
